import { html, classes } from '../core/html.js';
import { t } from '../core/i18n.js';
import { storeLinks } from './storeLinks.js';

/** Catalogue card. App metadata is rendered as-is; the frame is editorial. */
export const productCard = (item, { namespace, media, index = 0 }) => {
  const title = t(`${namespace}.${item.slug}.title`);
  const genre = item.genreKey ? t(item.genreKey) : '';
  const genreSlug = item.genreKey ? item.genreKey.split('.').pop() : '';

  return html`
    <article
      class="${classes('game-card', item.upcoming && 'game-card--upcoming')}"
      style="--accent: ${item.accent ?? '#2b4a6f'}"
      data-card
      data-genre="${genreSlug}"
      data-reveal
    >
      <div class="game-card__media">
        ${media}
        <span class="game-card__index" aria-hidden="true">${String(index + 1).padStart(2, '0')}</span>
        <span class="${classes('game-card__state', item.upcoming && 'game-card__state--upcoming')}">
          ${item.upcoming ? t('state.upcoming') : t('state.live')}
        </span>
      </div>
      <div class="game-card__body">
        <h3 class="game-card__title">${title}</h3>
        <p class="game-card__meta">
          ${genre}${item.platforms ? html`<span aria-hidden="true"> · </span>${item.platforms.join(' · ')}` : ''}
        </p>
        <p class="game-card__text">${t(`${namespace}.${item.slug}.description`)}</p>
        <ul class="tag-list">
          ${item.tagKeys.map((key) => html`<li>${t(key)}</li>`)}
        </ul>
        <div class="game-card__actions">
          ${item.upcoming
            ? html`<span class="game-card__soon">${t('state.upcoming')}</span>`
            : storeLinks(title, item.stores)}
        </div>
      </div>
    </article>
  `;
};
